import React from "react";
import { Icon, MenuItem, Spinner, Tag } from "@blueprintjs/core";
import { Suggest } from "@blueprintjs/select";

class AsyncSelWrap extends React.Component {
  state = {
    item: null,
    width: "100px",
  };

  renderMI = (item, query) => {
    return (
      <div className={this.props.isColfax ? "colfax" : "axis"}>
        {this.highlightText(item.item, query)}
        {item.entityTypeString ? <br /> : null}
        {item.entityTypeString ? (
          <Tag minimal>{item.entityTypeString}</Tag>
        ) : null}
        {item.helper ? <Icon icon="caret-right" minimal /> : null}
        {item.helper ? <Tag minimal>{item.helper}</Tag> : null}
        {item.helper2 ? <Icon icon="caret-right" minimal /> : null}
        {item.helper2 ? <Tag minimal>{item.helper2}</Tag> : null}
      </div>
    );
  };
  renderItem = (item, { handleClick, modifiers, query }) => {
    if (!modifiers.matchesPredicate) {
      return null;
    }
    let label = null;

    return (
      <MenuItem
        className={this.props.isColfax ? "colfax" : "axis"}
        style={{ width: "300px" }}
        active={modifiers.active}
        disabled={modifiers.disabled}
        onClick={handleClick}
        text={this.renderMI(item, query)}
        shouldDismissPopover={false}
        label={label}
      />
    );
  };
  escapeRegExpChars = (text) => {
    return text.replace(/([.*+?^=!:${}()|[\]/\\])/g, "\\$1");
  };
  highlightText = (text, query) => {
    let lastIndex = 0;
    const words = query
      .split(/\s+/)
      .filter((word) => word.length > 0)
      .map(this.escapeRegExpChars);
    if (words.length === 0) {
      return [text];
    }
    const regexp = new RegExp(words.join("|"), "gi");
    const tokens = [];
    while (true) {
      const match = regexp.exec(text);
      if (!match) {
        break;
      }
      const length = match[0].length;
      const before = text.slice(lastIndex, regexp.lastIndex - length);
      if (before.length > 0) {
        tokens.push(before);
      }
      lastIndex = regexp.lastIndex;
      tokens.push(<strong key={lastIndex}>{match[0]}</strong>);
    }
    const rest = text.slice(lastIndex);
    if (rest.length > 0) {
      tokens.push(rest);
    }
    return tokens;
  };
  handleItemSelect = (item) => {
    this.setState({ item: item.item });
    this.props.onChange(item);
  };
  filterItem = (query, item) => {
    /** Implement Any Random Search Here which returns a Boolean */
    /** Correspondingly IF you want aesthetics, change `highlightText` */
    return true;
  };
  setFocus() {
    this.searchInputInside.focus();
  }
  render() {
    let inputProps = {};
    if (this.props.placeholder) {
      inputProps["placeholder"] = this.props.placeholder;
    }
    if (!this.props.width) {
      inputProps["style"] = { width: "400px" };
    }
    let items = this.props.items;

    return (
      <Suggest
        query={this.props.query}
        className={this.props.isColfax ? "colfax" : "axis"}
        onQueryChange={(event) => this.props.update(event)}
        inputProps={{
          onBlur: () => {
            if (this.props.isClinicalComplicatedThing) {
              this.props.onBlur();
            }
          },
          onFocus: () => {
            if (this.props.isClinicalComplicatedThing) {
              this.props.onFocus();
            }
          },
          inputClassName: this.props.isColfax ? "colfax" : "axis",
          className: this.props.isColfax ? "colfax focus-input" : "axis",
          placeholder: this.props.placeholder || "Search...",
          autoFocus: this.props.autoFocus,
        }}
        itemPredicate={(query, item) => {
          return true;
        }}
        items={items}
        noResults={
          this.props.searching ? (
            <MenuItem
              disabled={true}
              className={this.props.isColfax ? "colfax" : "axis"}
              label={<Spinner size={20} />}
              text="Searching..."
            />
          ) : (
            <MenuItem
              className={this.props.isColfax ? "colfax" : "axis"}
              disabled={true}
              text="Start typing to search."
            />
          )
        }
        itemRenderer={this.renderItem}
        selectedItem={
          this.state.item
            ? this.state.item
            : this.props.selectedItem
            ? this.props.selectedItem
            : null
        }
        onItemSelect={this.handleItemSelect}
        inputValueRenderer={(item) => item}
        popoverProps={{ minimal: true }}
      />
    );
  }
}

export default AsyncSelWrap;
